<template>
  <div style = 'height:0;visibility:hidden;overflow:hidden;'>
    <iframe ref = 'print_iframe'></iframe>
    <div ref = 'print_template'>
     
      <div style = 'padding:20px;padding-top:40px;'>
        <!-- <div style = "height:60px;border-bottom:2px dashed #333;">
          <div style = "height:40px;width:40px;float:left;">
            <img style = "height:40px;width:40px;" :src = "envConst.API_BASE_URL+$store.state.main.tenant.tenantLogoLittle" />
          </div>
          <div style = "height:40px;line-height:50px;float:right;font-size:18px;">
            {{userName}}
          </div>
        </div> -->
        <div style = 'padding:0;font-size:24px;text-align:center;color:#333;font-wight:600;'>
          {{userName}}
        </div>
        <div style = "padding:15px 0;font-size:18px;text-align:center;font-weight:200;">{{params.business_type}}</div>
        <!-- <div style = 'font-size:12px;color:#9999A4;'>
          <div style = 'padding-bottom:5px;'>提交人：<span>{{params.create_by}}</span></div>
          <div style = 'clear: both;'>
            <div style = 'float:left;padding-bottom:5px;'>提交时间：<span>{{params.create_date}}</span></div>
            <div style = 'float:right;padding-bottom:5px;'>更新时间：<span>{{params.update_date}}</span></div>
          </div>
        </div> -->
        <table border = '1' style = 'border-radius:5px;border-collapse: collapse;border:1px solid #333;width:100%;text-align:left;'>
          <colgroup>
            <col width = "20%" />
            <col width = "30%" />
            <col width = "20%" />
            <col width = "30%" />
          </colgroup>
          <tbody>
              <tr  :key = 'index' v-for = '(items,index) in dataTh'>
                <template  v-for = '(item,i) in items' >
                  <td :key = "i" v-if = "item.fieldsType == 'groupTitle'" colspan="4" style = 'padding:5px 10px;'>{{item.fieldsTitle}}</td>
                  <td :key = "i" v-else style = 'color:#999;padding:5px 10px;'>{{item.componentName}}</td>
                  <td :key = "i" v-if = "item.fieldsType != 'groupTitle'" style = 'color:#999;padding:5px 10px;' :colspan="(item.fieldType == 1||items.length == 1||item.fieldType==15||item.componentCode == 'order_name')?3:1">
                    <span v-if = 'item.fieldType!=15&&item.fieldType!=16&&item.fieldType!=1' >{{item.value}}</span>
                    <div v-if = 'item.fieldType ==1 ' style = "min-height: 90px;">{{item.value}}</div>
                    <div v-for = '(child,index) in item._itemValue' :key = "index">
                      {{`${child.fileName}.${child.fileType}`}}
                    </div>
                    <div  v-if = 'item.fieldType==15' style = "width:100%;">
                      <img v-show = 'i_item' style = 'width:80px;margin-right:10px;' :key = 'index1' v-for = '(i_item,index1) in item.value.split(",")' :src = '`${envConst["API_BASE_URL"]}/file/filemanage/downloadFileById/${i_item}`' />
                    </div>
                  </td>
                  <!-- <td :key = "i" v-if = "items.length == 1&&item.fieldsType != 'groupTitle'&&item.fieldType != 1" colspan="2"></td> -->
                </template>
              </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import envConst from '@/env-const.js'
export default {
  data(){
    return {
      dataTh: [],
      params: {},
      title: '',
      envConst,
      userName: JSON.parse(localStorage.user).info.domainName
    }
  },
  created(){

  },
  methods: {
    _template(){
      return this.$refs['print_template'].innerHTML
    },
    concatArr(data,params){
      let arr = []
      let tabsList = data.tabsList
      let tabsListCol = tabsList.Parameter.colList
      if(tabsListCol.length){
        for(let i in tabsListCol){
          if(tabsListCol[i].title == "资料"){
            arr = arr.concat(tabsListCol[i].children)
          }
        }
      }
      let renderArr = []
      let waitInArr = []
      for(let i in arr){
        arr[i].value = params[arr[i].componentCode] || ''
        if(arr[i].fieldType == '14'){
          arr[i].value = this.filterAreaType(arr[i].value)
        }
        if((arr[i]&&(arr[i].fieldsType == 'groupTitle' || arr[i].fieldType == '1'|| arr[i].fieldType== '15' || arr[i].componentCode == 'order_name'))){
          if(waitInArr.length){
            renderArr.push([...waitInArr])
            waitInArr = []
          }
          renderArr.push([arr[i]])
        }else{
          waitInArr.push(arr[i])
          if(waitInArr.length == 2||i == (arr.length-1)){
            renderArr.push([...waitInArr])
            waitInArr = []
          }
        }
      }
      return renderArr
    },
    initPrint(data,params){
      if(data.listRightItem.length){
        this.title = params[data.listRightItem[0].componentCode]
      }
      this.params = params
      this.dataTh = this.concatArr(data,params)
      let printWindow = this.$refs['print_iframe'].contentWindow
      console.log('th--',this.dataTh)
      this.$nextTick(() => {
        this.getFlowList(this.params.flow_instance_id,()=>{
          printWindow.document.body.innerHTML = this.cutHead()+this._template()
        })
             
      })
    },
    print(data,params){
      let printWindow = this.$refs['print_iframe'].contentWindow
       printWindow.document.body.innerHTML = this.cutHead()+this._template() 
      printWindow.print()
    },
    getFlowList(id,cb){
      if(!id){
        cb&&cb()
        return
      }
      this.$http.get(envConst.SCMD_API_BASE + "/scmd/flow/getProcessComments/" + `${id}`).then((res) => {
        this.$nextTick(()=>{
          cb&&cb()
        })
      })
    },
    filterAreaType(value){
      if(value){
          let _i = getIndex(value,"/",3)
          let _val141 = value
          _val141 = _val141.substring(0,_i-1).split("/")
          let _val142 = value.substring(_i,value.length)
          return _val141.join("")+_val142
      }else{
        return value
      }
    },
    cutHead(){
      return `<style media="print">
          @page {
            size: auto;  /* auto is the initial value */
            margin: 0mm; /* this affects the margin in the printer settings */
          }
      </style>`
    }
  }
}
function getIndex(str,strpram,index){
  var strValue=str;
  var strValue1="";
  var value=0;
  for(var i =0;i < index;i++){
  strValue1 = strValue.substring(0,strValue.indexOf(strpram));
  strValue = strValue.substring(strValue1.length+1);
  value += (strValue1.length+1);
  }
  return value;
}
</script>

<style>

</style>
